// extracted by mini-css-extract-plugin
export default {"PlainFeature":"vy_a bhi_b"};